<template>
    <div class="main">
        <div class="nav">
            <Nav :title="'面访签到'" :arrow="true"></Nav>
        </div>
        <div>
            <van-panel title="基本信息">
            </van-panel>
            <van-form>
                <van-field v-model="subject" name="主题" label="主题" placeholder="主题" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写主题' }]" />
                <van-field v-model="client" name="相关客户" label="相关客户" placeholder="相关客户" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写相关客户' }]" />
                <van-field v-model="mahyfl" name="行业分类" label="行业分类" placeholder="" readonly label-width="140" />
                <van-field v-model="remark1" v-if="typeleixing == 1 || typeleixing == 2" name="备注" label="备注" placeholder=""
                    readonly label-width="140" />
                <!-- 客户行业分类类别变更 -->
                <!-- <van-field readonly clickable name="picker" :value="hyflvalue" label="客户行业分类是否变更" placeholder="客户行业分类是否变更" label-width="140"
                    @click="hyflshowclockin = true" /> -->
                <!-- <van-popup v-model="hyflshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="HYFLTYPE" @confirm="onConfirmclockihyfl" @cancel="hyflshowclockin = false"
                       />
                </van-popup> -->
                <!-- 客户行业分类变更 -->
                <van-field readonly clickable name="picker" :value="hyflxuanvalue" label="变更后行业分类" placeholder="变更后行业分类"
                    label-width="140" @click="hyflbgshowclockin = true" />
                <van-popup v-model="hyflbgshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="hyflbglist" @confirm="onConfirmclockihyflbg"
                        @cancel="hyflbgshowclockin = false" value-key="codevalue" />
                </van-popup>



                <van-field v-model="assignee" name="被分配人" label="被分配人" placeholder="被分配人" readonly label-width="140"
                    :rules="[{ required: true, message: '请填写被分配人' }]" />
                <van-field name="checkboxGroup" label="参与拜访人员" label-width="140">
                    <template #input>
                        <van-checkbox-group v-model="visiting_personnel" direction="horizontal">
                            <van-checkbox class="checkbox" name="MSR" shape="square">MSR</van-checkbox>
                            <van-checkbox class="checkbox" name="分公司经理" shape="square">分公司经理</van-checkbox>
                            <van-checkbox class="checkbox" name="省总经理理" shape="square">省总经理理</van-checkbox>
                            <van-checkbox class="checkbox" name="省服务经理" shape="square">省服务经理</van-checkbox>
                            <van-checkbox class="checkbox" name="省销售经理" shape="square">省销售经理</van-checkbox>
                            <van-checkbox class="checkbox" name="分公司销售经理/主管" shape="square">分公司销售经理/主管</van-checkbox>
                            <van-checkbox class="checkbox" name="省租赁经理" shape="square">省租赁经理</van-checkbox>
                            <van-checkbox class="checkbox" name="省二手机经理" shape="square">省二手机经理</van-checkbox>
                            <van-checkbox class="checkbox" name="省零件服务销售经" shape="square">省零件服务销售经</van-checkbox>

                        </van-checkbox-group>
                    </template>
                </van-field>
                <!-- 整机/拜访目的 -->
                <van-field name="checkboxGroup" label="整机/拜访目的" label-width="140">
                    <template #input>
                        <van-checkbox-group v-model="bfmdkgvalue" direction="horizontal">
                            <van-checkbox class="checkbox" name="山工业务相关" shape="square">山工业务相关</van-checkbox>
                            <van-checkbox class="checkbox" name="整机业务相关" shape="square">整机业务相关</van-checkbox>
                            <van-checkbox class="checkbox" name="二手机业务相关" shape="square">二手机业务相关</van-checkbox>
                            <van-checkbox class="checkbox" name="租赁业务相关" shape="square">租赁业务相关</van-checkbox>
                        </van-checkbox-group>
                    </template>
                </van-field>
                <!-- <van-field readonly clickable name="picker" :value="bfmdkgvalue" label=" 整机/拜访目的" placeholder="请选择整机/拜访目的" label-width="140"
                    @click="mfmdbgshowclockin = true" />
                <van-popup v-model="mfmdbgshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="baifangmudilist" @confirm="onConfirmclockibfmdkg" @cancel="mfmdbgshowclockin = false"
                       />
                </van-popup> -->
                <!-- 客户工程开工情况 -->
                <van-field readonly clickable name="picker" :value="khgckgvalue" label="客户工程开工情况" placeholder="请选择客户工程开工情况"
                    label-width="140" @click="khgckgshowclockin = true" />
                <van-popup v-model="khgckgshowclockin" position="bottom">
                    <van-picker show-toolbar :columns="khgckgmudilist" @confirm="onConfirmkhgckg"
                        @cancel="khgckgshowclockin = false" />
                </van-popup>
                <!-- 打卡信息 -->
                <van-field readonly clickable name="picker" :value="dakavalue" label="打卡信息" placeholder="点击选择打卡信息"
                    label-width="140" @click="showclockin = true" />
                <van-popup v-model="showclockin" position="bottom">
                    <van-picker class="picker-action-font-size" show-toolbar :columns="clockinArr"
                        @confirm="onConfirmclockin" @cancel="showclockin = false" value-key="clockintext" />
                </van-popup>
                <!-- <van-address-list
  v-model="chosenAddressId"
  :list="clockinArr"
  :disabled-list="disabledList"
  :show-add-button="false"
/> -->
                <van-field v-model="baifangtext" type="textarea" name="拜访内容" label="拜访内容" placeholder="拜访内容" rows="1"
                    label-width="140" autosize :rules="[{ required: true, message: '请填写拜访内容' }]" />
                <div class="image">
                    <van-image fit="contain" :src="dakaimg" />
                </div>
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" @click="onSubmit" color="#FBAC01">发
                        布</van-button>
                </div>
            </van-form>
        </div>
        <!-- loading -->
        <van-overlay :show="showloading">
            <div style="width: 100%;height: 100%;display: grid;place-items: center;">
                <van-loading type="spinner" color="#1989fa" />
            </div>

        </van-overlay>
    </div>
</template>

<script>
import { qiweiAPI } from '../../api/qiwei.js';
import Nav from './component/nav.vue';
import { Dialog } from 'vant';
export default {
    components: {
        Nav,
    },
    data() {
        return {
            typeleixing: this.$route.query.type,
            subject: `面访签到[${this.$route.query.name || this.$route.query.khmc}]`,
            client: this.$route.query.name || this.$route.query.khmc,
            baifangtext: '',
            assignee: '',
            dakavalue: '',
            hyflvalue: '是',
            hyflxuanvalue: '',
            khgckgvalue: '',
            bfmdkgvalue: [],
            value: '',
            mahyfl: this.$route.query.mahyfl || this.$route.query.Mahyfl,
            // DOTO备注  
            remark1: this.$route.query.remark1 || '',
            columns: ['MSR', '分公司经理', '省总经理理', '省服务经理', '省销售经理', '分公司销售经理/主管', '省租赁经理', '省二手机经理', '省零件服务销售经'],
            clockinArr: [],
            showclockin: false,
            // hyflshowclockin: false,
            hyflbgshowclockin: false,
            khgckgshowclockin: false,
            mfmdbgshowclockin: false,
            showloading: false,
            visiting_personnel: [],
            qw_clock_in_data: '',
            hyflbglist: [],
            khgckgmudilist: ['正常开工', '暂停工', '部分开工', '已停工'],
            baifangmudilist: ['山工业务相关', '整机业务相关', '二手机业务相关', '租赁业务相关'],
            dakaimg: '',
            // HYFLTYPE:['是','否'],
            start_date: new Date().getTime()
        };
    },
    mounted() {
        console.log(this.$route.query);
        this.getClockInData()
        this.getUserData()
        this.getIndustryClassData()

    },
    methods: {
        onSubmit(values) {

            this.showloading = true
            if (this.$route.query.typename == '高开工设备') {
                this.$route.query.ownerid = this.$route.query.userid
                this.$route.query.name = this.$route.query.khmc
                this.$route.query.id = this.$route.query.crmid
            }
         
            var params = {
                qw_user_id: this.$t.qiwei_yuangong_num,   //用户id
                crm_customer_code: this.$route.query.khbmccc,   //客户编码
                qw_clock_in_id: this.qw_clock_in_data,  //打卡数据数组格式
                client: this.client,   //客户
                subject: this.subject,   //主题
                assignee: this.assignee,   //呗分配人
                visiting_personnel: this.visiting_personnel,    //参与拜访人员,
                crm_data: this.$route.query,

                visiting_contents: this.baifangtext,   //拜访内容
                visiting_source: this.$route.query.visiting_source,   //拜访来源
                industry_class: this.$route.query.mahyfl || this.$route.query.Mahyfl,    //行业分类
                is_change: this.hyflvalue,    //是否变更行业分类
                change_industry_class: this.hyflxuanvalue,    //变更后行业分类
                purpose_machine_visit: this.bfmdkgvalue,    //整机拜访目的
                operation_status: this.khgckgvalue,    //客户工程开工情况
                type: this.$route.query.type,  //:1=客户,2=大客户,3=商机,4=出差申请
                start_date: this.start_date,
                // DOTO
                remark1: this.remark1
            }

            this.$axios.post(
                qiweiAPI.interviewSignIn,
                params,
                {
                    headers: this.$t.headers
                }

            )
                .then((res) => {
                    console.log(res)
                    this.showloading = false
                    if (res.data.code == 1) {
                        Dialog.alert({
                            title: '提示',
                            message: '提交成功',

                        }).then(() => {
                            this.$router.push({ path: '/qiwei/mianqian' })
                        });

                    } else {
                        Dialog.alert({
                            title: '提示',
                            message: res.data.msg,

                        })
                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },
        // 行业变更类型选择
        // onConfirmclockihyfl(value, index) {
        //     this.hyflvalue = value
        //     if(value=='否'){
        //         this.hyflxuanvalue = ''
        //     }
        //     this.hyflshowclockin= false
        // },
        // 行业变更选择
        onConfirmclockihyflbg(value, index) {
            console.log(value)
            this.hyflxuanvalue = value.codevalue
            // if(this.hyflvalue=='否'){
            //     this.hyflxuanvalue = ''
            // }
            this.hyflbgshowclockin = false
        },
        // 整机拜访目的
        onConfirmclockibfmdkg(value, index) {
            this.bfmdkgvalue = value
            this.mfmdbgshowclockin = false
        },

        // 客户工程开工
        onConfirmkhgckg(value, index) {
            this.khgckgshowclockin = false
            this.khgckgvalue = value
            console.log(this.khgckgvalue)
        },

        onConfirmclockin(value, index) {
            console.log(value);

            this.dakavalue = this.clockinArr[index].location_detail;
            this.showclockin = false;
            console.log(`当前值：${value}, 当前索引：${index}`);

            // 绑定图片
            this.$axios
                .post(qiweiAPI.getMediaData, {
                    clockin_data: value,
                }, {
                    headers: this.$t.headers
                }
                )
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.dakaimg = res.data.data.oss_attachments[0]
                        this.qw_clock_in_data = res.data.data.id
                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },

        // 获取打卡信息
        getClockInData() {
            this.$axios
                .get(qiweiAPI.getClockInData, {
                    params: {
                        qw_user_id: this.$t.qiwei_yuangong_num
                    },
                    headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.clockinArr = res.data.data
                    }
                })
                .catch((res) => {
                    console.log(res);

                });
        },
        // 获取用户信息
        getUserData() {
            this.$axios
                .get(qiweiAPI.getUserData, {
                    params: {
                        qw_user_id: this.$t.qiwei_yuangong_num
                    },
                    headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.assignee = res.data.data.name

                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },
        // 获取行业分类
        getIndustryClassData() {
            this.$axios
                .get(qiweiAPI.getIndustryClassData,
                    {
                        headers: this.$t.headers,
                    }
                )
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.hyflbglist = res.data.data.data

                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },

    },
}
</script>

<style>
.main {
    width: 100%;
}

.checkbox {
    margin-bottom: 6px;
}

.image {
    width: 100%;
    margin-top: 20px;
    display: grid;
    place-items: center;
    overflow: hidden;
}

.image>.van-image {
    width: 80%;
    overflow: hidden;
}

.image img {
    width: 100%;
    overflow: hidden;
}

.picker-action-font-size {
    font-size: 10px;

}

.van-picker-column {
    font-size: 12px;
}

.van-ellipsis {
    font-size: 12px;
    text-align: center;
    white-space: normal;
    /* text-overflow: ellipsis; */
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/checkin.vue